import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import Button from '@material-ui/core/Button';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';

import PageHeading from 'components/PageHeading';
import TableSortCell from 'components/TableSortCell';
import TableActionCell from 'components/TableActionCell';
import TableCount from 'components/TableCount';

class RestaurantsListPage extends React.PureComponent {
  handleSort = (sortName, sortDirection) => {
    return this.props.onSort({ sortName, sortDirection });
  };

  handleSync = () => {
    this.props.onOHEICSSync();
  };

  render() {
    const { items } = this.props.initialData;
    const { sortName, sortDirection } = this.props;
    return (
      <div>
        <PageHeading
          title="Restaurants"
          right={
            <Button
              onClick={this.handleSync}
              variant="contained"
              color="primary"
              size="large"
            >
              OHEICS Sync
            </Button>
          }
        />
        <TableCount count={items.length} />
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableSortCell
                  title="Restaurant"
                  sortName="name"
                  currentSortName={sortName}
                  currentSortDirection={sortDirection}
                  handleSort={this.handleSort}
                />
                <TableSortCell
                  title="Street address"
                  sortName="js:streetAddress"
                  currentSortName={sortName}
                  currentSortDirection={sortDirection}
                  handleSort={this.handleSort}
                />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.streetAddress}</TableCell>
                  <TableActionCell
                    link={`/restaurant-details/${item.id}`}
                    icon="edit"
                  />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

RestaurantsListPage.propTypes = {
  initialData: PropTypes.shape({
    items: PropTypes.array,
  }).isRequired,
  sortName: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  onOHEICSSync: PropTypes.func.isRequired,
};

export default RestaurantsListPage;
